.workspace-section {
    display: flex;
    height: 100%;
    background-color: white;
    border-radius: 3px;
    overflow: visible !important;
    gap: 12px;
}

.navigation-tabs-container {
    position: sticky;
    top: 100px;
    height: fit-content;
    /* Render on top of AI summary widget */
    z-index: 2;
    max-width: 175px;
}

.navigation-tabs-container > div {
    padding: 0 0 0 16px;
}

.content {
    flex: 1;
    overflow-y: visible;
    padding: 0 16px 16px 0;
    min-width: 0;
}

.content--full-height-sidebar {
    padding-bottom: 0;
}
